import React from 'react'
import { string } from 'prop-types'

import { Tooltip, Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function InfoTooltipText({ text }) {
  return (
    <p className="cgt-legacy-text-tiny cgt-legacy-text-tiny--dark-bg">{text}</p>
  )
}

function InfoTooltip({ text }) {
  return (
    <Tooltip
      id="tooltip-id"
      randomizeID
      content={<InfoTooltipText text={text} />}
    >
      <Icon
        color="dark"
        size="small"
        svgComponent={InfoOutlined}
        withHover
      />
    </Tooltip>
  )
}

InfoTooltipText.propTypes = {
  text: string.isRequired,
}

InfoTooltip.propTypes = {
  text: string.isRequired,
}

export default InfoTooltip
